import React from "react";
import PropTypes from "prop-types";
import PrimaryButton from "components/v3/primary-button/PrimaryButton";
import Modal from "components/v3/modal/Modal";
import {
    SOCIAL_MEDIA,
    SOCIAL_NO_EMAIL_ERROR_TYPE,
    TERMINAL_NON_BBA_ERROR_TYPE
} from "common/constants/Constants";
import styles from "./styles.module.scss";

const AlertModal = React.memo(({ error: { socialType, message } = {}, isOpen, onClose }) => {
    return (
        <Modal isOpen={ isOpen } onClose={ onClose }>
            <div className={ styles.alertModalContent }>
                { getErrorByType(socialType, message) }
                <PrimaryButton onClick={ onClose } text="OK" />
            </div>
        </Modal>
    );
});

function getErrorByType(errorType, message) {
    switch (errorType) {
        case `${ SOCIAL_NO_EMAIL_ERROR_TYPE }-${ SOCIAL_MEDIA.FACEBOOK }`:
        case `${ SOCIAL_NO_EMAIL_ERROR_TYPE }-${ SOCIAL_MEDIA.TWITTER }`:
        case SOCIAL_NO_EMAIL_ERROR_TYPE:
            return getNoEmailError(errorType);
        case TERMINAL_NON_BBA_ERROR_TYPE:
            return getNonBBAError();
        default:
            return genericError(message);
    }
}

function genericError(message) {
    return (
        <p className={ styles.primaryMessage }>
            { message }
        </p>
    );
}

function getNoEmailError(errorType) {
    const socialMediaType = deduceSocialError(errorType);

    return (
        <div>
            <p className={ styles.primaryMessage }>
                We were not able to create a Bloomberg.com account because there is no email address associated with
                your <span className={ styles.socialSite }>{ socialMediaType }</span> account.
            </p>
            <p className={ styles.secondaryMessage }>
                Please sign up with an email address instead.
            </p>
        </div>
    );
}

function getNonBBAError() {
    return (
        <div>
            <p className={ styles.primaryMessage }>Only Bloomberg Anywhere clients have access to Bloomberg.com content.
                <br />
                <a className={ styles.learnMore } rel="noopener" target="_blank" href="https://www.bloomberg.com/professional/product/remote-access/">Learn More</a>
            </p>
            <p className={ styles.secondaryMessage }>
                You can access Bloomberg.com by going to&nbsp;
                <a className={ styles.secondaryMessageLink } href="bbg://screens/BBG">BBG &lt;GO&gt;</a> on the Terminal.
            </p>
        </div>
    );
}

function deduceSocialError(errorType) {
    // format is SOCIAL_NO_EMAIL_ERROR_TYPE-SOCIAL_MEDIA_TYPE
    if (!errorType || typeof errorType !== "string") {
        return "";
    }

    const socialSource = errorType.split("-")[1];

    if (socialSource !== SOCIAL_MEDIA.FACEBOOK && socialSource !== SOCIAL_MEDIA.TWITTER) {
        return "";
    }

    return socialSource;
}

AlertModal.propTypes = {
    error: PropTypes.object,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func.isRequired
};

AlertModal.defaultProps = {
    isOpen: false
};

export default AlertModal;
